"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = require("react");

var useCarouselTimers = function useCarouselTimers(transition, state, setState) {
  (0, react_1.useEffect)(function () {
    if (state.nextIndex !== undefined) {
      setTimeout(function () {
        return setState(function (prev) {
          var _a;

          return Object.assign(Object.assign({}, prev), {
            activeIndex: (_a = prev.nextIndex) !== null && _a !== void 0 ? _a : 0,
            nextIndex: undefined
          });
        });
      }, transition);
    }

    if (state.prevIndex !== undefined) {
      setTimeout(function () {
        return setState(function (prev) {
          var _a;

          return Object.assign(Object.assign({}, prev), {
            activeIndex: (_a = prev.prevIndex) !== null && _a !== void 0 ? _a : 0,
            prevIndex: undefined
          });
        });
      }, transition);
    }
  }, [transition, state.prevIndex, state.nextIndex, setState]);
};

exports.default = useCarouselTimers;